<script lang="ts">
	import { t } from '#lib/i18n/state.svelte';
	import { authState } from '#lib/auth/store.svelte';

	interface Props {
		onclose: () => void;
	}
	let { onclose }: Props = $props();
	const auth = authState();
	let busy = $state(false);

	async function upgrade() {
		if (!auth.isLoggedIn) {
			window.location.href = '/auth/login';
			return;
		}
		busy = true;
		try {
			const res = await fetch('/api/billing/checkout', { method: 'POST', credentials: 'include' });
			if (res.ok) {
				const data = (await res.json()) as { url?: string };
				if (data.url) window.location.href = data.url;
			}
		} finally {
			busy = false;
		}
	}
</script>

<div class="overlay">
	<div class="modal" role="dialog" tabindex="-1" aria-modal="true" aria-label={t('auth.limit.title')}>
		<h2>{t('auth.limit.title')}</h2>
		<p>{t('auth.limit.body')}</p>
		<div class="actions">
			<button class="btn btn-primary" onclick={upgrade} disabled={busy}>{t('auth.limit.upgrade')}</button>
			<button class="btn btn-ghost" onclick={onclose}>{t('auth.limit.later')}</button>
		</div>
	</div>
</div>

<style>
	.overlay {
		position: fixed;
		inset: 0;
		background: rgb(28 25 23 / 0.45);
		display: grid;
		place-items: center;
		padding: 1rem;
		z-index: 70;
	}
	.modal {
		width: min(26rem, 100%);
		background: var(--paper);
		border: 1px solid var(--line);
		border-radius: var(--radius);
		padding: 1.3rem;
		box-shadow: 0 24px 60px rgb(0 0 0 / 0.22);
	}
	h2 {
		margin: 0 0 0.5rem;
		font-size: 1.15rem;
	}
	p {
		margin: 0 0 1rem;
		color: var(--ink-2);
		font-size: 0.9rem;
	}
	.actions {
		display: flex;
		gap: 0.5rem;
		flex-wrap: wrap;
	}
</style>
